import React, { Component }  from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'
import BackIcon from './icons/BackIcon'

export class Back extends Component{
	render(){
		return(
			<div
				style={{
					textDecoration: 'none'
				  , backgroundColor: "rgb(41, 48, 56)"
				  , width: "55px"
				  , height: "60px"
				  , textAlign: "left"
				  , paddingTop: "0px"
				  , borderBottom: "1px solid rgb(225, 227, 226)"
				  , display: "inline-block"
				}}
				onClick={()=>{this.props.goBack()}}
			  >
				<BackIcon />
			</div>
		)}
}

export default connect(null,  routerActions)(Back)



// WEBPACK FOOTER //
// ./src/components/Back.js